import { SessionCoach } from "../../models/session.model";
import * as dataStorageService from "./session.service";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

const cookieHostname = window.location.hostname.startsWith(".")
	? window.location.hostname.substring(1)
	: window.location.hostname;

/**
 * Cookie names are scoped per origin (hostname) so that PROD and UAT (and other
 * environments) do not share the same token. Otherwise logging in on PROD then
 * visiting UAT would reuse the PROD token and API calls would fail.
 */
const getTokenCookieName = (): string => `k-token--${cookieHostname}`;
const getTwilioCookieName = (): string => `k-t-token--${cookieHostname}`;

const LEGACY_TOKEN_COOKIE = "k-token";
const LEGACY_TWILIO_COOKIE = "k-t-token";

/** Remove legacy shared cookies so they are not reused across environments. */
const clearLegacyCookiesIfPresent = (): void => {
	try {
		if (cookies.get(LEGACY_TOKEN_COOKIE)) {
			cookies.remove(LEGACY_TOKEN_COOKIE, { path: "/" });
		}
		if (cookies.get(LEGACY_TWILIO_COOKIE)) {
			cookies.remove(LEGACY_TWILIO_COOKIE, { path: "/" });
		}
	} catch {
		// ignore
	}
};
clearLegacyCookiesIfPresent();

/**
 * SESSION
 */

// Session > DELETE
export const deleteSession = (): void => {
	dataStorageService.deleteItem("k-user");
	deleteCookieToken();
	deleteTwilioCookieToken();
};

// Session > SET
export const setSession = (userData: SessionCoach, token: string): void => {
	dataStorageService.setItem("k-user", userData);
	setCookieToken(token);
};

// Session storage > SET User
export const setSessionStorageUser = (userData: SessionCoach): void => {
	dataStorageService.setItem("k-user", userData);
};

// Session storage > GET User
export const getSessionStorageUser = (): SessionCoach => dataStorageService.getItem("k-user");

/**
 * COOKIE
 */

// Cookie > DELETE Token
export const deleteCookieToken = (): void => {
	cookies.remove(getTokenCookieName(), { domain: cookieHostname, path: "/" });
};

// Cookie > DELETE Twilio Token
export const deleteTwilioCookieToken = (): void => {
	cookies.remove(getTwilioCookieName(), { domain: cookieHostname, path: "/" });
};

// Cookie > SET expiration date (8 hours)
const setCookieExpirationDate = (): Date => {
	const expirationDate: Date = new Date();
	expirationDate.setHours(expirationDate.getHours() + 9);
	return expirationDate;
};

// Cookie > SET Token
export const setCookieToken = (token: string): void =>
	cookies.set(getTokenCookieName(), token, {
		expires: setCookieExpirationDate(),
		domain: cookieHostname,
		path: "/",
	});

// Cookie > GET Token
export const getCookieToken = (): string => cookies.get(getTokenCookieName()) ?? "";

// Cookie > Check token validity
export const validCookieToken = (): boolean => !!cookies.get(getTokenCookieName());

// Cookie > SET Twilio Token
export const setTwilioCookieToken = (token: string): void =>
	cookies.set(getTwilioCookieName(), token, {
		expires: setCookieExpirationDate(),
		domain: cookieHostname,
		path: "/",
	});

// Cookie > GET Twilio Token
export const getTwilioCookieToken = (): string => cookies.get(getTwilioCookieName()) ?? "";

// Cookie > Check Twilio Token validity
export const validTwilioCookieToken = (): boolean => !!cookies.get(getTwilioCookieName());
